import { register, CloudObject, defineProperty, defineRelation, Direction } from 'olympe';

/**
 * @extends {CloudObject}
 */
export default class InspectionState extends CloudObject {
    /**
     * @return {number}
     */
    getRank() {
        return this.get(InspectionState.rankProp);
    }

    /**
     * @return {string}
     */
    getValue() {
        return this.get(InspectionState.valueProp);
    }
}

// Hardcoded tags
register('01880b4835d929a774f3', InspectionState);
InspectionState.rankProp = defineProperty('01880b48d5c6bdf451dd');
InspectionState.valueProp = defineProperty('01880b48f864664d098d');
InspectionState.dependenciesRel = defineRelation('01880b489cf5f1fdd6a1', InspectionState, InspectionState);
InspectionState.inverse_inspectionStatedependenciesRel = defineRelation('01880b489cf5f1fdd6a1', Direction.ORIGIN);
InspectionState.inverse_inspectionEntitypresumedStatesRel = defineRelation('01880b497227ef6db299', Direction.ORIGIN);
InspectionState.inverse_unitstatesRel = defineRelation('0188d02dd595cf5ad17d', Direction.ORIGIN);
